import React from 'react';
import DateComponent from '/components/forms-v2/Date.component';

const DateOfArrivalInput = ({ control }) => {
  return <DateComponent name='arrivalDate' control={control} label='Arrival to Stockholm' />;
};

export default DateOfArrivalInput;
